export const env = {
  STAGING: 'staging',
  STAGING2: 'staging2',
  PRODUCTION: 'production',
};

export const STAGE = env.STAGING2;